document.addEventListener('DOMContentLoaded', function () {
  var popupLinks = document.querySelectorAll('a[href="#newsletter-popup"]');

  popupLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      // Ensure Klaviyo onsite object exists
      window._klOnsite = window._klOnsite || [];

      // Replace YOUR_FORM_ID_HERE with the actual Klaviyo form ID
      window._klOnsite.push(['openForm', 'QXZrzF']);
    });
  });
});
